<template>
  <div class="cus-card" :style="[customStyle]">
    <div class="cus-card-title" v-if="showTitle">
      <div>{{title}}</div>
      <slot name="title-right"></slot>
    </div>
    <slot name="header"></slot>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "cus-card",
    props: {
      showTitle: {
        type: Boolean,
        default: true,
      },
      title: {
        type: String,
        default: '供应商列表'
      },
      customStyle: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
  }
</script>

<style scoped lang="less">
  .cus-card{
    padding: 0 24px 20px;
    background: white;
    width: 100%;
    min-width: 500px;
    border: 1px solid #e6ebf5;;
    box-shadow: 0 2px 12px 0 #e6ebf5;
    &-title{
      height: 65px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
    }
  }
</style>



// WEBPACK FOOTER //
// src/cuview-ui/components/cus-card/cus-card.vue